<template>
  <div class="content">
    <h3 ref="pageHeader" :style="{ '--width': widthVar }" class="pageHeader">{{ $store.state.themeTitle }}项目审批</h3>
    <div>
      <el-form :inline="true" :model="formInline" class="demo-form-inline" label-position="left">
        <el-form-item label="组织结构">
          <OrganDialog ref="organDia1" @getSelect="getSelect1" :level="levell" @handleOrganQuery="handleOrganQuery1">
          </OrganDialog>
          <el-input v-model="organLabel" placeholder="请选择" style="width:320px;" @focus="dialogOpen1"
            @clear="handeleClear1" clearable></el-input>
        </el-form-item>
        <el-form-item label="审批状态">
          <el-select v-model="formInline.status" clearable filterable placeholder="请选择">
            <el-option v-for="item in $store.state.applyStatus2" :key="item.value" :label="item.label"
              :value="item.value"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item :label="`${$store.state.themeTitle}项目编号`">
          <el-input v-model="formInline.experiment_code" clearable placeholder="请输入"></el-input>
        </el-form-item>
        <el-form-item :label="`${$store.state.themeTitle}项目名称`">
          <el-input v-model="formInline.experiment_name" clearable placeholder="请输入"></el-input>
        </el-form-item>
        <el-form-item :label="`${$store.state.themeTitle}类别`">
          <el-select v-model="formInline.experiment_category" clearable filterable placeholder="请选择">
            <el-option v-for="item in $store.state.experimentCategorys" :key="item" :label="item"
              :value="item"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item :label="`${$store.state.themeTitle}类型`">
          <el-select v-model="formInline.experiment_type" clearable filterable placeholder="请选择">
            <el-option v-for="item in $store.state.experimentTypes" :key="item" :label="item" :value="item"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item :label="`课程名称`">
          <el-input v-model="formInline.course_name" clearable placeholder="请输入"></el-input>
        </el-form-item>
        <el-form-item :label="`所属${$store.state.themeTitle}室`">
          <el-select v-model="formInline.training_name" clearable filterable
            :placeholder="`请选择所属${$store.state.themeTitle}室`">
            <el-option v-for="item in $store.state.trainRooms" :key="item.id" :label="item.training_name"
              :value="item.training_name"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item :label="`${$store.state.themeTitle}要求`">
          <el-select v-model="formInline.experiment_requirement" clearable filterable placeholder="请选择">
            <el-option v-for="item in $store.state.experimentRequirements" :key="item" :label="item"
              :value="item"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="handleQuery">查询</el-button>
        </el-form-item>
      </el-form>
    </div>
    <div>
      <custom-table :data="tableData" border style="width: 100%">
        <custom-table-column fixed label="序号" type="index" width="50">
        </custom-table-column>
        <custom-table-column prop="experiment_name" fixed :label="`${$store.state.themeTitle}项目名称`" width="160px">
        </custom-table-column>
        <custom-table-column prop="experiment_code" :label="`${$store.state.themeTitle}项目编号`" width="160px">
        </custom-table-column>
        <custom-table-column prop="status_text" label="审批状态" width="100">
        </custom-table-column>
        <custom-table-column prop="status_remark" label="审批原因" width="160">
        </custom-table-column>
        <custom-table-column prop="instructor_name" label="指导老师" width="120">
        </custom-table-column>
        <custom-table-column prop="training_room_name" :label="`所属${$store.state.themeTitle}室`" width="160">
        </custom-table-column>
        <custom-table-column prop="structure_1" label="所属院系" width="180">
        </custom-table-column>
        <custom-table-column prop="structure_2" label="专业" width="180">
        </custom-table-column>
        <custom-table-column prop="task_name" label="典型任务名称" width="160">
        </custom-table-column>
        <custom-table-column prop="course_name" label="所属课程名称" width="160">
        </custom-table-column>
        <custom-table-column prop="term" label="学年学期" width="200">
        </custom-table-column>
        <custom-table-column prop="is_virtual" label="是否仿真虚拟项目" :formatter="format_status_iss" width="160">
        </custom-table-column>
        <custom-table-column prop="resource_names" label="配套资源名称" width="160">
        </custom-table-column>
        <custom-table-column prop="experiment_category" :label="`${$store.state.themeTitle}类别`" width="160">
        </custom-table-column>
        <custom-table-column prop="experiment_type" :label="`${$store.state.themeTitle}类型`" width="160">
        </custom-table-column>
        <custom-table-column prop="experiment_requirement" :label="`${$store.state.themeTitle}要求`" width="160">
        </custom-table-column>
        <custom-table-column prop="skill_requirement" label="技能要求" width="160">
        </custom-table-column>
        <custom-table-column prop="assessment_method" label="考核方式" width="160">
        </custom-table-column>
        <custom-table-column prop="module_count" label="模块数量" width="160">
        </custom-table-column>
        <custom-table-column prop="is_external_service" label="是否对外服务" :formatter="format_status_iss" width="160">
        </custom-table-column>
        <custom-table-column prop="participant_types" :label="`${$store.state.themeTitle}者类别`" width="160">
        </custom-table-column>
        <custom-table-column prop="participant_count" :label="`${$store.state.themeTitle}人数`" width="160">
        </custom-table-column>
        <custom-table-column prop="group_size" label="每组人数" width="160">
        </custom-table-column>
        <custom-table-column prop="experiment_hours" :label="`${$store.state.themeTitle}学时数`" width="160">
        </custom-table-column>
        <custom-table-column prop="other_location" label="其他实训地点" width="160">
        </custom-table-column>
        <custom-table-column fixed="right" label="操作" width="120">
            <template slot-scope="scope" v-if="scope.row.status == 1">
              <el-button @click="handleOper(scope.row, 2, '通过')" type="text" size="small">通过</el-button>
              <el-button @click="handleOper(scope.row, 3, '否决')" type="text" size="small">否决</el-button>
            </template>
        </custom-table-column>
      </custom-table>
      <div class="pageLine">
        <PageLine :total='total' ref="pageChild" @getList="getList"></PageLine>
      </div>
    </div>
    <el-dialog :close-on-click-modal="false" :title="title" :visible.sync="centerDialogVisible" width="510px">
      <el-form :model="ruleForm" ref="ruleForm" label-width="100px" class="demo-ruleForm">
        <el-form-item label="说明原因" prop="status_remark" :rules="isRefuse">
          <el-input type="textarea" placeholder="请输入" :rows="4" v-model="ruleForm.status_remark"
            style="width:336px;"></el-input>
        </el-form-item>
        <el-form-item style="margin-top:8px;width:100%;text-align:right;">
          <el-button type="primary" @click="submitFormByFun('ruleForm', setStatus)">提交</el-button>
          <el-button @click="resetForm('ruleForm')" style="margin-right:24px;">重置</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
import { mixinList } from '@/assets/js/mixin/list';
import { mixinValidate } from '@/assets/js/mixin/validate';
import { mixinFormatter } from '@/assets/js/mixin/formatter';
import { mixinOrgan } from '@/assets/js/mixin/organization';

export default {
  name: 'equipmentInto',
  mixins: [mixinList, mixinValidate, mixinFormatter, mixinOrgan],
  data() {
    return {
      formInline: {
        experiment_code: '',
        experiment_name: '',
        experiment_category: '',
        experiment_type: '',
        structure_1: '',
        structure_2: '',
        course_name: '',
        training_room_id: '',
        experiment_requirement: '',
      },
      ruleForm: {
        id: '',
        status: '',
        status_remark: ''
      }
    };
  },
  created() {
    // 
  },
  computed: {
    isRefuse() {
      return this.ruleForm.status == 3?[{ required: true, message: '请输入', trigger: 'blur' }]:[];
    },
  },
  mounted() {
  },
  methods: {
    async getList() {
      let params = this.$until.deleteNullPrototype(this.formInline);
      params.page = this.$refs.pageChild.page;
      params.size = this.$refs.pageChild.size;
      let res = await this.$api.instance.interfaceServer('api/course-project-applications/list', 'get', params);
      if (res.code == 0 && res.data) {
        this.tableData = res.data.data;
        this.total = res.data.total;
      }
    },
    async setStatus() {
      let res = await this.$api.instance.interfaceServer(`api/course-project-applications/approve/${this.ruleForm.id}`, 'post', this.ruleForm);
      if (res.code == 0) {
        this.$message({
          type: 'success',
          center: true,
          message: '设置成功！',
        });
        this.centerDialogVisible = false
        this.getList();
      }
    },
    handleOper(row, status,str) {
      this.ruleForm.id = row.id
      this.ruleForm.status = status
      this.centerDialogVisible = true
      this.title = `${str}项目${row.experiment_name}的申请`
    },
    handleQuery() {
      this.beforeQueryByKeyNew({ major: 'structure_2' })
      this.$refs.pageChild.page = 1;
      this.getList();
    },
  },
};
</script>
<style lang="less" scoped>
.pageHeader:before {
  width: var(--width);
}
</style>
